import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import { Api } from "@api/index";
import { ApiButton } from "@api/components/ApiButton";
import { connectToApi, ApiConnectedOwnProps } from "@api/components/connectToApi";
import { AuthState } from "@auth/models";
import { FilesState } from "@files/models";
import { MusicState } from "@music/models";
import { messages } from "../../messages";
import { Bundle, UploadState } from "../../models";
import { getBundlesList, hasMorePages, getNextPage } from "../../selectors";
import { BundlesTable } from "../BundlesTable";

type State = UploadState & MusicState & FilesState & AuthState;

interface BundlesListStateProps extends ApiConnectedOwnProps {
    bundles: Bundle[];
    morePages: boolean;
    nextPage: number;
}

class BundlesList extends React.Component<BundlesListStateProps> {
    private loadMore() {
        const { nextPage } = this.props;
        return Api.bundlesIndex(nextPage);
    }

    public render() {
        const { bundles, morePages } = this.props;
        return (
            <div className="bundles-list">
                <BundlesTable bundles={bundles} />
                {morePages &&
                    <div className="bundles-list__load-more">
                        <ApiButton actionCreators={[() => this.loadMore()]}>
                            <FormattedMessage {...messages.loadMoreBundles} />
                        </ApiButton>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: State): BundlesListStateProps => {
    return {
        bundles: getBundlesList(state),
        morePages: hasMorePages(state),
        nextPage: getNextPage(state),
    };
};

const ConnectedBundlesList = compose(
    connect(mapStateToProps, null),
    connectToApi({ actionCreator: Api.bundlesIndex }),
)(BundlesList);

export {
    BundlesList as BundlesListPresenter,
    ConnectedBundlesList as BundlesList,
    BundlesListStateProps,
};
